import React, {useEffect} from 'react';
import styled from 'styled-components';
import { GuideBox, DetailBox, TitleBox, ViewBox } from '../../../components/atoms/Box';
import NextButton from '../../../components/atoms/Button/NextButton';
import GoBackButton from '../../../components/atoms/Button/GoBackButton';
import resultInfo from "../../../data/resultInfo";
import {inject, observer} from "mobx-react";
import {withRouter} from "react-router-dom";

const ResultDetailTemplate = inject("ResultStore")(observer((props) => {
    const type = props.match.params.type;

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <Wrap>
            <GoBackButton clickHandler={() => props.ResultStore.setIsResult(true)}/>
            <GuideBox order="2" />

            <TitleBox text="정밀 능력검사 수치" sty="32px" type={resultInfo.type[type].type}/>

            <div className="level_box">
                <ViewBox title="조망 능력검사" level={resultInfo.type[type].future}/>
                <ViewBox title="갈등 능력검사" level={resultInfo.type[type].conflict}/>
            </div>

            <DetailBox sty="20px" result={resultInfo.sub_results[type]}/>

            <div className="bt_box">
                <NextButton
                    text="내 연애 진단 받아보기"
                    bg="#efebe8"
                    lineColor="#262626"
                    color="#262626"
                    sty="64px"
                    clickHandler={() => {
                        if (window.fordate) {
                            window.location.href = "https://form.fordate.org";
                        } else {
                            window.location.href = "https://bit.ly/3gNkVmd";
                        }
                    }}
                />
                <NextButton
                    text="실시간 선생님 대화 시작"
                    bg="#262626"
                    lineColor="#fff"
                    color="#fff"
                    sty="64px"
                    clickHandler={() => {
                        if (window.fordate) {
                            window.location.href = "https://pf.kakao.com/_Fbcxfd/chat";
                        } else {
                            window.location.href = "https://bit.ly/2yXCLSl";
                        }
                    }}
                />
            </div>
        </Wrap>
    );
}));

const Wrap = styled.div`
    margin: 0 auto;
    width: 88%;
    padding-bottom: 71px;

    .level_box {
        margin-top: 30px;
    }
    .bt_box {
        margin-top: 71px;
    }
`;


export default withRouter(ResultDetailTemplate);
